export var TYPE_PLAYLIST_THUMBNAIL = 'playlist-thumbnail';
export var TYPE_ASSET_THUMBNAIL = 'asset-thumbnail';
export var TYPE_TOPIC_THUMBNAIL = 'topic-thumbnail';
export var TYPE_AVATAR = 'avatar';
export var TYPE_USER_IMPORT = 'userimport';
export var TYPE_ASSET = 'upload';
export var TYPE_SCORM = 'scorm';
export var TYPE_SUBTITLES = 'subtitles';
export var TYPE_ZIP = 'zip';
export var TYPE_DEFAULT = 'file';
export var TYPE_BADGE_IMAGE = 'badge-image';